const stateKeys = {
  data: 'history-data'
}

export const actions = {
  clearStorage() {
    for (const prop in stateKeys) {
      this.$storage.removeUniversal(stateKeys[prop])
    }
  },

  async getData({ dispatch }, { format, interval, startDateTime, update }) {
    let data
    if (update) {
      data = await this.$storage.getUniversal(stateKeys.data)
    } else {
      const startTime = this.$toSecondsFromEpoch(startDateTime)
      const timezoneOffset = startDateTime.getTimezoneOffset()

      data = await this.$apiAaltra.history(
        format._format,
        interval._period,
        startTime,
        timezoneOffset
      )

      this.$storage.setUniversal(stateKeys.data, data)
    }

    const result = await dispatch('map', {
      data: data ? data.values : null,
      format,
      interval
    })

    const historyChartDataEmpty = await dispatch(
      'energy/home/checkIfDatasetsDataAreEmpty',
      result ? result.barChartData : null,
      { root: true }
    )

    // Hide Tumble dryer and Toaster
    if (data.appliances.items.length) {
      if (data.appliances.items.length) {
        data.appliances.items.forEach((item, itemIdx) => {
          if (item.id === 43 || item.id === 28) {
            data.appliances.items.splice(itemIdx, 1)
          }
        })
      }
    }

    const appliances = {
      chartData: await dispatch(
        'energy/appliance/mapManyToChartData',
        { data: data.appliances.items, format },
        { root: true }
      ),
      listData: await dispatch(
        'energy/appliance/mapManyToListData',
        { data: data.appliances.items, format },
        {
          root: true
        }
      )
    }

    return {
      ...result,
      empty: historyChartDataEmpty,
      appliances
    }
  },

  map({ rootState, dispatch }, { data, format, interval }) {
    const unit =
      format._format === 'energy'
        ? this.app.i18n.t('kwh')
        : this.$currency.get()
    let averageKeyword = 'hourlyAverage'
    switch (interval._period) {
      case 'week':
        averageKeyword = 'dailyAverage'
        break
      case 'month':
        averageKeyword = 'dailyAverage'
        break
      case 'year':
        averageKeyword = 'monthlyAverage'
        break
    }

    const datasets = []
    const datastyles = []
    switch (format.text) {
      case 'grid':
        if (this.$storage.getUniversal('hasSolar')) {
          if (
            data.consumedSolar &&
            data.consumedSolar.data &&
            data.consumedSolar.data.length > 0
          ) {
            datasets.push(data.consumedSolar)
            datastyles.push(this.app.$chartDatasets('solar', 'bar'))
          }
          if (
            data.imported &&
            data.imported.data &&
            data.imported.data.length > 0
          ) {
            datasets.push(data.imported)
            datastyles.push(this.app.$chartDatasets('grid', 'bar'))
          }
        } else if (
          data.imported &&
          data.imported.data &&
          data.imported.data.length > 0
        ) {
          datasets.push(data.imported)
          datastyles.push(this.app.$chartDatasets('grid', 'bar'))
        }
        break
      case 'solar':
        if (
          data.consumedSolar &&
          data.consumedSolar.data &&
          data.consumedSolar.data.length > 0
        ) {
          datasets.push(data.consumedSolar)
          datastyles.push(this.app.$chartDatasets('solar', 'bar'))
        }
        if (
          data.exported &&
          data.exported.data &&
          data.exported.data.length > 0
        ) {
          datasets.push(data.exported)
          datastyles.push(this.app.$chartDatasets('solar-export', 'bar'))
        }
        break
      case 'currency':
        if (data.night && data.night.data && data.night.data.length > 0) {
          datasets.push(data.night)
          datastyles.push(this.app.$chartDatasets('currency-night', 'bar'))
        }
        if (data.day && data.day.data && data.day.data.length > 0) {
          datasets.push(data.day)
          datastyles.push(this.app.$chartDatasets('currency', 'bar'))
        }
        if (
          data.cashback &&
          data.cashback.data &&
          data.cashback.data.length > 0
        ) {
          datasets.unshift(data.cashback)
          datastyles.unshift(this.app.$chartDatasets('currency-export', 'bar'))
        }
        break
    }

    let totalTextKeyword = 'totalConsumption'

    if (format.text === 'solar') {
      totalTextKeyword = 'totalProduction'
    } else if (format.text === 'currency') {
      totalTextKeyword = 'energyCost'
    }

    let total = null
    if (data) {
      total =
        format.text === 'solar'
          ? data.generated
            ? data.generated.total
            : null
          : data.total
    }

    const totals = {
      colorLegend: datastyles
        .map((style) => this.$chartLegendColor(style.legend))
        .reverse(),
      text: this.app.i18n.t(totalTextKeyword),
      value: `${this.$formatEnergy(total) || 0}`
    }

    const subTotals = datastyles
      .map((style, index) => {
        return {
          chartLegend: {
            text: style.label,
            type: style.legend
          },
          values: this.$formatUnit(
            this.$formatEnergy(datasets[index]?.total || 0),
            unit
          )
        }
      })
      .reverse()

    if (data.fixed) {
      subTotals.push({
        chartLegend: {
          text: this.app.i18n.t('fixedCost')
        },
        values: this.$formatUnit(this.$formatEnergy(data.fixed || 0), unit)
      })
    }

    let average = null
    if (data) {
      average =
        format.text === 'solar'
          ? data.generated
            ? data.generated.average
            : null
          : data.average
    }

    return {
      unit,
      averageKeyword,
      average: average || 0,
      barChartData: {
        datastyles,
        totals,
        subTotals,
        labels: this.$labelsByPeriod(data.timestamps, interval._period),
        datasets: datasets.map((set) => {
          return {
            data: (set?.data || set)?.map((x) => x || null) || []
          }
        })
      }
    }
  }
}
